import type { FaireProductEntity } from "../../entity_types/product";

export const p_n2vswd6p2x: FaireProductEntity = {
  token: "p_n2vswd6p2x",
  type: "product",
  name: "BOATNECK DRESS IN OXFORD",
  brandToken: "b_9jdg5bykvm",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0d6ab399691bfaf7428c296f04b2ab2ac13c4f446311d852748007ab0b19417e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/03543d6f8ecc3682e05485a7b041d96464012af30e7621ef4aab5f19efde0e5f.png",
    "https://cdn.faire.com/fastly/34f4b0edd478009815bb3bc8b10224208f172a0370552a4819e05c726cabd2bf.png",
    "https://cdn.faire.com/fastly/53a13d65fca19c80a51be75427e4bb3ae96719a38ddc1e764105899b7bc3dbd1.png",
    "https://cdn.faire.com/fastly/be0ee09d586ccc9927093c10ecc8acbb03a7022e7d09fb3f34f2dc1bbdb1a907.png",
    "https://cdn.faire.com/fastly/15a55f6f859ab085154e4eedd1ffdfe307b95ca6c45ab342f6e4d28245740367.png",
  ],
  priceDollars: 67.9,
  description:
    "Our best selling mini dress is made from silky soft, lightweight eco-TENCEL™ that drapes beautifully on the body. Designed with an easy, flattering fit, it features long sleeves, a smooth boat neckline, and a contour seam under the bust for subtle shape. The mini-length skirt has a relaxed, effortless feel—comfortable enough for everyday wear, polished enough for going out. A versatile staple you can dress up or down all season long.\n\n * \nSilky soft, lightweight eco-TENCEL™\n\n * \nLong sleeves\n\n * \nBoat neckline\n\n * \nContour seam under bust\n\n * \nMini length (slightly shorter than standard)\n\n * \nMade in Los Angeles\n",
  tags: [],
  msrpDollars: 135.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:06.735Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
